import { Component, OnInit, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-monthly-water-dispense',
  templateUrl: './monthly-water-dispense.component.html',
  styleUrls: ['./monthly-water-dispense.component.scss']
})

export class MonthlyWaterDispenseComponent implements OnInit, OnChanges {
    @Input() data = [];
    mapdata: any;

    colorScheme = {
      domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA']
    };

    constructor() {
    }

    onSelect(event) {
    }

    ngOnInit() {
    }

    ngOnChanges() {
        this.mapdata = this.data.map( function(item) {
            return  { 'name': item.MonthName, 'value': item.WaterDispenseSum };
        });
    }
}
